import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef } from 'react';
import './Autocomplete.scss';
import { useDropdown, useKeyControlledList } from '../../hooks';
import { Input } from '../input/Input';
import { ListItem } from '../list/ListItem';
import { Popup } from '../popup/Popup';
export const Autocomplete = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
(props, ref) => {
    const popupTriggerRef = useRef(null);
    const popupContentRef = useRef(null);
    const inputRef = useRef(null);
    const [keyControlledListItemIndex, handleListControllerKeyDown, resetKeyControlledList] = useKeyControlledList(props.items.length);
    const [isDropdownShown, setDropdownShown, handleDropdownKeyDown] = useDropdown(popupTriggerRef, popupContentRef, resetKeyControlledList);
    const popupPosition = [
        'bottom-right',
        'bottom-center',
        'bottom-left',
        'top-right',
        'top-center',
        'top-left',
    ];
    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current?.focus();
        },
    }));
    function handleInputKeyDown(e) {
        handleDropdownKeyDown(e);
        handleListControllerKeyDown(e);
        switch (e.keyCode) {
            case 13: // Enter
                if (isDropdownShown && keyControlledListItemIndex !== undefined) {
                    e.preventDefault();
                    setDropdownShown(false);
                    handleItemClick(e, {
                        data: props.items[keyControlledListItemIndex],
                    });
                }
                break;
            default:
                if (!isDropdownShown) {
                    setDropdownShown(true);
                }
        }
        props.onKeyDown && props.onKeyDown(e, { name: props.name });
    }
    function handleInputClick() {
        setDropdownShown(true);
    }
    function handleInputBlur(e) {
        props.onBlur && props.onBlur(e, { name: props.name });
    }
    function handleInputChange(e, eventData) {
        if (eventData.value === '') {
            // Input clear button was clicked
            setDropdownShown(false);
        }
        props.onChange(e, eventData);
    }
    function handleItemClick(e, eventData) {
        setDropdownShown(false);
        props.onItemClick(e, { item: eventData.data, name: props.name });
        inputRef.current?.focus();
    }
    return (_jsxs("div", { className: 'sg-autocomplete sg-a-d-f sg-a-jc-s', ref: popupTriggerRef, children: [_jsx(Input, { ref: inputRef, name: props.name, type: 'text', value: props.value, placeholder: props.placeholder, hasClearBtn: props.hasClearBtn, icon: props.icon, autoComplete: 'off', isDisabled: props.isDisabled, isRequired: props.isRequired, isInvalid: props.isInvalid, onBlur: handleInputBlur, onKeyDown: handleInputKeyDown, onClick: handleInputClick, onChange: handleInputChange, testId: props.testId ? `${props.testId}-input` : undefined, children: props.children }), props.items && props.items.length > 0 && isDropdownShown && (_jsx(Popup, { position: popupPosition, triggerRef: popupTriggerRef, sameWidthAsTrigger: true, children: _jsx("div", { ref: popupContentRef, className: 'sg-autocomplete--list', children: _jsx("ul", { className: 'sg-autocomplete--listInner', "data-test-id": props.testId ? `${props.testId}-list` : undefined, children: props.items.map((item, index) => (_jsx(ListItem, { isActive: index === keyControlledListItemIndex, data: item, onPress: handleItemClick, children: _jsx("div", { className: 'sg-a-ml-2 sg-a-mr-2 sg-a-pt-1 sg-a-pb-1', children: props.renderItem ? props.renderItem(item) : item }) }, index))) }) }) }))] }));
});
//# sourceMappingURL=Autocomplete.js.map